import { GreenroomState } from '../types/types';

// eslint-disable-next-line import/prefer-default-export
export const selectSrtStreams = (state: GreenroomState) => {
	const { srtStreams, onsiteLocations } = state.VideoReducer;
	const onsiteSrtIds = new Set(onsiteLocations.map((location) => location.srtId));
	// split srt streams into standalone and those associated with onsite locations
	return {
		standaloneSrtStreams: srtStreams.filter((stream) => !onsiteSrtIds.has(stream.id)),
		onsiteSrtStreams: srtStreams.filter((stream) => onsiteSrtIds.has(stream.id)),
	};
};
